export const TOGGLE_LOADING = 'TOGGLE_LOADING';
export const TOGGLE_MENU = 'TOGGLE_MENU';
export const TOGGLE_TOAST = 'TOGGLE_TOAST';
export const SET_BUSINESS_UNITS = 'SET_BUSINESS_UNITS';
